import {useEffect, useRef} from 'react';
import {$getRoot, $insertNodes, ElementNode, LexicalNode} from 'lexical';
import {$generateNodesFromDOM} from '@lexical/html';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {nodeType as styledTextNodeType} from '../../../../../../../components/LexicalEditor/nodes/StyledText';
import {unwrapFontTags} from './utils';

interface Props {
    initialHtml?: string;
}

export const HtmlPlugin = ({initialHtml}: Props) => {
    const [editor] = useLexicalComposerContext();
    const isMounted = useRef(false);

    useEffect(() => {
        editor?.update(() => {
            if (isMounted.current) return;

            isMounted.current = true;

            if (initialHtml) {
                const parser = new DOMParser();
                const dom = parser.parseFromString(initialHtml.replace('<p >', ''), 'text/html');
                if (initialHtml.indexOf('<font') > 0) {
                    const fontTags = dom.getElementsByTagName('font');
                    unwrapFontTags(fontTags);
                }

                const nodes = $generateNodesFromDOM(editor, dom).filter(
                    (item: LexicalNode, index: number) => {
                        let firstEmptyLine = false;
                        if (index === 0 && item instanceof ElementNode) {
                            const children = item.getChildren();
                            firstEmptyLine = item.getTextContent() === '' && children.length === 0;
                        }

                        const isTextNode =
                            item.getType() === 'text' || item.getType() === styledTextNodeType;
                        // Include image nodes (DecoratorNodes) and block nodes, but exclude problematic text nodes
                        // that would crash the editor when inserted at root level
                        return !(isTextNode || firstEmptyLine);
                    }
                );
                $getRoot().clear();
                $getRoot().select();
                $insertNodes(nodes);
            }

            $getRoot().selectStart();
        });
    }, [editor, initialHtml]);

    return null;
};
